module.exports = __webpack_public_path__ + "img/zw.zwcd37458.svg";